import React, { useEffect, useState, useMemo } from 'react';
import { Grid, Typography, Box, Button, Checkbox, TextField } from '@mui/material';
import Layout from 'Component/Layouts/layout';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setData, markAttendence, selectAll, setbatchId, removeAll } from 'reducer/attendenceSlice';
import { updateAttendence, fetchAttendanceByBatchId } from 'thunks/attendenceSliceThunks/thunks';
import { toast } from 'react-toastify';
import TableComponent from 'Component/Table';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { red, green, grey } from '@mui/material/colors';
import HailIcon from '@mui/icons-material/Hail';
import CalculateIcon from '@mui/icons-material/Calculate';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

const Attendence = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const batchId = useMemo(() => queryParams.get('batchId'), [location]);
  const [tableData, setTableData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [count, setCount] = useState(10);
  const dispatch = useDispatch();
  dispatch(setbatchId(batchId));

  const {
    isLoading,
    isSuccess,
    isError,
    errorMessage,
    data: attendenceData,
    selectAllClicked,
  } = useSelector((state) => state.attendenceSlice);

  const renderAction = (row, date) => {
    let value = row[date];

    let icon, checkedIcon, color;

    if (value === 'true') {
      icon = <CheckCircleIcon sx={{ color: green[600] }} />;
      checkedIcon = <CheckCircleIcon sx={{ color: green[600] }} />;
    } else if (value === 'false') {
      icon = <CancelIcon sx={{ color: red[800] }} />;
      checkedIcon = <CancelIcon sx={{ color: red[800] }} />;
    } else {
      // Handle "NA" or any other value
      icon = <RemoveCircleOutlineIcon sx={{ color: grey[500] }} />;
      checkedIcon = <RemoveCircleOutlineIcon sx={{ color: grey[500] }} />;
    }

    return (
      <Checkbox icon={icon} checkedIcon={checkedIcon} disabled={true} checked={value === 'true'} />
    );
  };

  useEffect(() => {
    dispatch(fetchAttendanceByBatchId(batchId));
    if (attendenceData?.status === 'success') {
      let tempColumns = [
        { label: 'EmpID', field: 'empId' },
        { label: 'Name', field: 'name' },
      ];
      attendenceData.data.attendance.forEach((elem) => {
        tempColumns.push({
          label: elem.date,
          field: elem.date,
          render: (row) => renderAction(row, elem.date),
        });
      });
      setColumns(tempColumns);

      let tempDataArray = [];
      attendenceData.data.batchTrainees.forEach((elem) => {
        let rowData = {
          empId: elem.id,
          name: elem.name,
        };
        attendenceData.data.attendance.forEach((attendance, index) => {
          rowData[tempColumns[index + 2].field] = attendance.present.includes(elem.id)
            ? 'true'
            : attendance.absent.includes(elem.id)
              ? 'false'
              : 'NA';
        });
        tempDataArray.push(rowData);
      });
      console.log('tempDataArray', JSON.stringify(tempDataArray));
      setTableData(tempDataArray);
    }
  }, [attendenceData?.status]);

  return (
    <Layout>
      <Box sx={{ padding: '20px' }}>
        <Grid container spacing={3}>
          {/* Header Section */}
          <Grid item xs={12}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '20px',
                padding: '16px',
                borderRadius: '8px',
                backgroundColor: '#f8f9fa',
              }}
            >
              <TextField
                label={`Search EmpID Batch:${batchId}`}
                variant="outlined"
                size="small"
                autoFocus
                sx={{
                  width: 250,
                }}
                onChange={(e) => {
                  const query = e.target.value.trim();

                  // Ensure only numbers are allowed
                  if (!/^\d*$/.test(query)) {
                    console.log('Only numeric values are allowed.');
                    return;
                  }

                  if (query) {
                    const currentTableData = [...tableData];
                    console.log('currentTableData', currentTableData, query);

                    // Find the item based on partial match
                    const filteredItem = currentTableData.find((item) =>
                      item.empId.toString().includes(query.toString())
                    );
                    console.log('filteredItem', filteredItem);

                    if (filteredItem) {
                      // Filter out the item to avoid duplicates and add it at the beginning
                      const updatedTableData = [
                        filteredItem,
                        ...currentTableData.filter(
                          (item) => item.empId.toString() !== filteredItem.empId.toString()
                        ),
                      ];

                      console.log('updatedTableData', updatedTableData);
                      setTableData(updatedTableData);
                    }
                  } else {
                    // If input is cleared, reset tableData to its original state (optional)
                    console.log('Reset logic for table data if needed.');
                  }
                }}
              />
              <Box
                sx={{
                  display: 'flex',
                  margin: '2px',
                  justifyContent: 'space-between',
                  gap: '16px',
                }}
              >
                <Button
                  variant="contained"
                  startIcon={<CalculateIcon />}
                  onClick={() => navigate(`/attendance/stats?batchId=${batchId}`)}
                  disabled={!batchId}
                >
                  View Stats
                </Button>
                <Button
                  variant="contained"
                  startIcon={<HailIcon />}
                  onClick={() => navigate(`/attendance/mark?batchId=${batchId}`)}
                  disabled={!batchId}
                >
                  Mark Attendance!
                </Button>
              </Box>
            </Box>
          </Grid>

          {/* Table Section */}
          <Grid item xs={12}>
            <Box
              sx={{
                borderRadius: '8px',
                padding: '16px',
                backgroundColor: '#fff',
              }}
            >
              <span>** This is a view only section, use button above to Update Attendence.</span>
              <TableComponent
                tableData={tableData}
                setTableData={setTableData}
                columns={columns}
                tableName={'Attendance List'}
                count={tableData?.length}
                rowClickedKey={'empId'}
                naviagtionPath={`/training/?batch=`}
                useWholeRowClicked={false}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Layout>
  );
};

export default Attendence;
